export default __webpack_public_path__ + "static/notes-icon-0e831cf84361295e8310ccf83e59005d.png";